<div class="container" [ngClass]="{ 'container-extension': isShown }">
  <div class="flex justify-between items-center">
    <div class="flex items-center">
      <div class="icon flex items-center justify-center">
        <svg-icon
          (click)="toggleAll()"
          key="{{ isShown ? 'less' : 'add' }}"
          class="cursor-pointer"
          size="{{ isShown ? 'md' : 'xl' }}"></svg-icon>
      </div>
      <h3 class="mx-6 title">{{ title }}</h3>
    </div>
  </div>
  <div id="content" *ngIf="seeContent" class="content">
    <div>
      <p class="p__indicator">
        <strong
          ><span>{{ isLomloe ? ('f.activity.rubrics.rule' | translate) : ('f.activity.rubrics.indication' | translate) }}</span
          >:</strong
        >
        {{ evaluationItemSubTitle?.split(':').pop() }}
      </p>
      <div class="container__evaluation__ranks">
        <div *ngFor="let item of rubricInfoArray; let i = index" class="item">
          <div (click)="isEvaluable ? setNote(item.range.max) : null" [ngClass]="{ 'cursor-pointer': isTeacher && isEvaluable }">
            <svg-icon key="{{ item.icon }}" size="xxl"></svg-icon>
          </div>
          <div class="content__evaluation__ranks" [ngClass]="{ 'content-selected': item.icon.includes('colored') }">
            <span
              >{{ 'f.activity.rubrics.level.label' | translate }} {{ i + 1 }} ({{ item.range.min }} -
              <ng-template [ngIf]="item.range.max !== 10" [ngIfElse]="fullNumber">{{ item.range.max - 0.01 }}</ng-template>
              <ng-template #fullNumber>{{ item.range.max }}</ng-template
              >)
            </span>
            <p>{{ item.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    *ngIf="
      seeContent &&
        isTeacher &&
        evaluationNote !== '' &&
        evaluationNote !== '-' &&
        route.snapshot.url[0]?.path === appRoutes.evaluation &&
        isEvaluable &&
        !isEvaluated &&
        groupHasStudents() | async
    "
    class="content__select_student"
    (click)="openAssessmentModal(content.subCompetenceId)">
    <svg-icon key="icon-user-plus" class="cursor-pointer" size="xxl"></svg-icon>
    <p class="bodySMedium">{{ 'f.activity.rubrics.select' | translate }}</p>
  </div>
</div>
